<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import FormattedContent from 'next/message/bubbles/Text/FormattedContent.vue';
import MessageMeta from 'next/message/MessageMeta.vue';
import { useMessageContext } from 'next/message/provider.js';
import { WhatsAppTemplateDocument } from 'dashboard/services/WhatsAppTemplateDocument';

const { content, attachments, additionalAttributes } = useMessageContext();

const attributes = computed(() => additionalAttributes.value || {});
const templateDocument = computed(() =>
  WhatsAppTemplateDocument.fromMessage(
    attributes.value,
    attachments.value || []
  )
);
const footer = computed(() => templateDocument.value.footerText);
const buttons = computed(() => templateDocument.value.buttons);
const imageUrl = computed(() => templateDocument.value.imageUrl);
</script>

<template>
  <BaseBubble
    hide-meta
    class="w-[360px] max-w-full overflow-hidden !p-0 !bg-n-background !text-n-slate-12 border border-n-weak shadow-sm"
    data-bubble-name="whatsapp-campaign-template"
  >
    <a
      v-if="imageUrl"
      :href="imageUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="block bg-n-alpha-black2"
    >
      <img
        :src="imageUrl"
        class="block object-cover w-full aspect-[4/3] skip-context-menu"
      />
    </a>

    <div class="px-3 pt-3 pb-2">
      <FormattedContent v-if="content" :content="content" />

      <p v-if="footer" class="mt-2 mb-0 text-xs text-n-slate-11">
        {{ footer }}
      </p>

      <MessageMeta class="justify-end mt-1 text-n-slate-11" />
    </div>

    <div v-if="buttons.length" class="border-t border-n-weak">
      <template
        v-for="(button, index) in buttons"
        :key="`${button.type}-${index}`"
      >
        <a
          v-if="button.type === 'URL' && button.url"
          :href="button.url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center justify-center px-3 py-2.5 font-medium text-n-teal-11 hover:bg-n-alpha-black2"
          :class="{ 'border-t border-n-weak': index > 0 }"
        >
          {{ button.text }}
        </a>
        <div
          v-else
          class="flex items-center justify-center px-3 py-2.5 font-medium text-n-teal-11"
          :class="{ 'border-t border-n-weak': index > 0 }"
        >
          {{ button.text }}
        </div>
      </template>
    </div>
  </BaseBubble>
</template>
